import React from 'react';
import { Navigate } from "react-router-dom";
import useAuth from '../../Hooks/useAuth';
import TopBar from '../TopBar/TopBar';
const StudentRoute = ({ children }) => {
    const isLoggedIn = useAuth();

    return isLoggedIn ? <>
        <TopBar></TopBar>
        {children}
    </> : <Navigate to="/" />;
};

export default StudentRoute;